var itemsArray = [
    {
        "item_id": 5423452345,
        "user_id": "bllarkin",
        "description": "Macbook Pro",
        "category": 5,
        "location_x": 33.459679,
        "location_y": -112.0549142,
        "verified": true,
        "available": true,
        "return_date": null,
        "sku": "ASU12345"
    },
    {
        "item_id": 34573456,
        "user_id": "jwdouble",
        "description": "Dell XPS",
        "category": 5,
        "location_x": 33.3880863,
        "location_y": -111.8722263,
        "verified": true,
        "available": false,
        "return_date": null,
        "sku": "ASU12345"
    },
    {
        "item_id": 34583456,
        "user_id": "jlabrec",
        "description": "Raspberry Pi",
        "category": 5,
        "location_x": 34.3870863,
        "location_y": -111.8722263,
        "verified": false,
        "available": true,
        "return_date": null,
        "sku": "ASU12345"
    }
]

module.exports = itemsArray